import { MultiChoiceProps } from "./QuizTypes";
import { MultiChoiceSelectedSVG, MultiChoiceSVG } from "./SVG";
import './Quiz.css';
const MultiChoice: React.FC<MultiChoiceProps> = ({
    value,
    selectedOptions,
    handleCheckboxChange,
    styleConfig,
    themeConfig,
    newId,
    isV1Api,
    formDataSecondary,
    questThemeData,
    optionsHeader,
    optionRankFormat,
    unselectedSvg,
    selectedSvg,
    optionCheckboxes,
    multiTranslatedTitle
}) => {
    const translatedCriteria = formDataSecondary.find(
        (criteria: any) => criteria.criteriaId === value.criteriaId
    );

    const optionRank = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

    return (
        <>
            {optionsHeader == true && <p className="quiz-options-header">{multiTranslatedTitle}</p>}
            <div className="quiz-header-ques-options multi-option">
                {value?.options.map((option: string, index: number) => {
                    const SelectedBorder = {
                        border: `2px solid ${questThemeData?.accentColor || '#9035FF'}`,
                        fontFamily: themeConfig?.fontFamily,
                    };

                    const SelectedOptionColor = {
                        color: styleConfig?.OptionsSelectedColor?.color || '#9035FF',
                        fontFamily: themeConfig?.fontFamily,
                    };

                    const isSelected = selectedOptions[value[newId]]?.includes(option);

                    return (
                        <div
                            key={index}
                            onClick={() => handleCheckboxChange(option, value[newId])}
                            className={`${isSelected ? "selected-option" : "not-selected"}`}
                            style={
                                isSelected
                                    ? SelectedBorder
                                    : { borderColor: themeConfig?.borderColor }
                            }
                        >
                            {optionRankFormat === 'alphabetic' && <span className="option-rank">{optionRank[index]}</span>}
                            {optionRankFormat === 'number' && <span className="option-rank">{index + 1}</span>}
                            <p
                                style={
                                    isSelected
                                        ? SelectedOptionColor
                                        : {
                                            color: themeConfig?.primaryColor,
                                            fontFamily: themeConfig?.fontFamily,
                                        }
                                }
                            >
                                {isV1Api ? translatedCriteria?.options[index] : option}
                            </p>
                            {optionCheckboxes === true ? isSelected ? selectedSvg || MultiChoiceSelectedSVG(styleConfig?.OptionsSelectedColor?.color) : unselectedSvg || MultiChoiceSVG(themeConfig?.borderColor) : null}
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default MultiChoice;